import React, { useContext, useCallback, useMemo } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import {
  Caption1Strong,
  Button,
  makeStyles,
  tokens,
  mergeClasses,
  useId,
} from '@fluentui/react-components';
import { Toaster, Toast, ToastTitle, useToastController } from '@fluentui/react-toast';
import { useBulkLocationsSearchContext } from './bulk-locations-search-provider';

const useStyles = makeStyles({
  unmatchedLocations: {
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
  header: {
    alignItems: 'center',
    display: 'flex',
    columnGap: tokens.spacingHorizontalS,
    marginTop: tokens.spacingVerticalMNudge,
    marginBottom: tokens.spacingVerticalMNudge,
  },
});

const UnmatchedLocations = () => {
  const i18n = useContext(I18nContext);
  const classes = useStyles();
  const toasterId = useId('BulkLocationsSearchCopyToaster');
  const { dispatchToast } = useToastController(toasterId);
  const { unmatchedLocations } = useBulkLocationsSearchContext();
  const unmatchedText = useMemo(() => unmatchedLocations?.join('\n'), [unmatchedLocations]);

  const handleCopyUnmatched = useCallback(() => {
    navigator.clipboard.writeText(unmatchedText)
      .then(() => dispatchToast(
        <Toast>
          <ToastTitle>
            {i18n.getString(_TL_('Locations copied to clipboard'))}
          </ToastTitle>
        </Toast>,
        { intent: 'success', position: 'top', timeout: 3000 }
      ));
  }, [dispatchToast, i18n, unmatchedText]);

  return (
    <React.Fragment>
      <div className={classes.header}>
        <Caption1Strong>{i18n.getString(_TL_('Not found locations ({{count}})'), { count: unmatchedLocations.length })}</Caption1Strong>
        <Toaster toasterId={toasterId} />
        <Button onClick={handleCopyUnmatched} size="small">
          {i18n.getString(_TL_('Copy all'))}
        </Button>
      </div>
      <p className={mergeClasses(classes.unmatchedLocations, 'unmatched-locations-textarea')} >
        {unmatchedText}
      </p>
    </React.Fragment >
  );
};

export default UnmatchedLocations;
